import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import './assets/global.css';
import 'flowbite';
import 'vue-masonry-css'

import { MotionPlugin } from '@vueuse/motion'

const app = createApp(App);
app.use(router);
app.use(MotionPlugin);

app.mount("#app");
